import { render, staticRenderFns } from "./UpdateAssetLimit.vue?vue&type=template&id=da3bf9bc&scoped=true"
import script from "./UpdateAssetLimit.vue?vue&type=script&lang=js"
export * from "./UpdateAssetLimit.vue?vue&type=script&lang=js"
import style0 from "./UpdateAssetLimit.vue?vue&type=style&index=0&id=da3bf9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3bf9bc",
  null
  
)

export default component.exports